import { Svg, SvgProps } from '@pancakeswap/uikit'

/**
 * Active (filled) state of the Profile tab: the filled twin of uikit's AccountIcon (head and shoulders).
 * Replaces AccountFilledIcon, which is PancakeSwap's bunny and showed up on a tap of Profile (Bez, 2026-10-02).
 */
const ProfileFillIcon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="7.5" r="4.75" />
    <path d="M12 13.75c-4.55 0-8.25 1.95-8.25 4.6 0 1.83 1.38 3.36 3.2 3.55l.3.03c3.16.3 6.34.3 9.5 0l.3-.03c1.82-.19 3.2-1.72 3.2-3.55 0-2.65-3.7-4.6-8.25-4.6Z" />
  </Svg>
)

export default ProfileFillIcon
